import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.scss'
import 'element-plus/theme-chalk/index.css'
import i18n from './i18n'

const app=createApp(App)
app.use(router)
app.use(i18n)
//定义clickOutSide指令
app.directive('clickOutSide',{
    beforeMount:(el,binding)=>{
        //console.log(binding)
        el.onClickOutSide=(e:MouseEvent)=>{
            if(el.contains(e.target)||el==e.target)return
            if(typeof binding.value=='function'){
                binding.value&&binding.value(e)
            }else{
                binding.value.handler&&binding.value.handler(binding.value.param)
            }
        }
        document.addEventListener('click',el.onClickOutSide)
    },
    unmounted:(el)=>{
        document.removeEventListener('click', el.onClickOutSide)
    }
})
app.mount('#app')